import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/bunkhouse/GalleryDetail.tsx");
